export const state = () => ({
  flashAlert: {
    isDisplayed: false,
    message: '',
    type: 'success',
    autoHide: false,
  },
});

export const getters = {
  getFlashAlert: state => state.flashAlert,
  isFlashAlertDisplayed: state => state.flashAlert.isDisplayed,
};

export const mutations = {
  showFlashAlert(state, { message, type, autoHide }) {
    state.flashAlert.isDisplayed = true;
    state.flashAlert.message = message;
    state.flashAlert.type = type;
    state.flashAlert.autoHide = autoHide;
  },
  hideFlashAlert(state) {
    state.flashAlert.isDisplayed = false;
    state.flashAlert.message = '';
    state.flashAlert.type = 'success';
    state.flashAlert.autoHide = false;
  },
};

export const actions = {
  showFlashAlert({ commit, dispatch }, { message, type = 'info', hideClose = false, autoHide = false, holdTime = 1500 }) {
    commit('hideFlashAlert');
    setTimeout(() => {
      commit('showFlashAlert', {
        message,
        type,
        autoHide,
      });
      if (autoHide) {
        setTimeout(() => commit('hideFlashAlert'), holdTime);
      }
    }, 200);
  },
  hideFlashAlert({ state, commit }) {
    if (state.flashAlert.isDisplayed) {
      commit('hideFlashAlert');
    }
  },
};
